<template>
    <div>
        <steps :currentStep="currentStep" @switchStep="switchStep"></steps>

        <div class="new-product">
            <div class="my-4">
                <div v-if="step === currentStep">
                    <form @submit.prevent.stop="switchStep" novalidate  @input="productAcivateUpdateFlag('pickups')">
                        <div class="d-flex justify-content-end align-items-center border-bottom-light my-4 p-4">
                            <button type="button" class="btn blue wider mr-3" @click="prevStep"><i class="ico-arrow-left fs-normal ml-2"></i> Back</button>
                            <button type="button" class="btn cancel wider mr-3" @click="cancel">Cancel</button>
                            <button type="button" class="btn green wider mr-3" @click="readyToSave">Save</button>
                        </div>

                        <div class="px-4">
                            <div class="row">
                                <div class="col-sm-8">
                                    <div class="panel shaded">
                                        <h5>Pickups</h5>

                                        <div class="fs-small dark mt-2 mb-3">
                                            Select the type of pickup available for this activity.
                                        </div>

                                        <div class="form-group pt-4">
                                            <div class="row">

                                                <div class="col-sm-4">
                                                    <radio name="pickups" :value="false" v-model="pickups" @input="pickupsOptionChanged">
                                                        No Pickups
                                                    </radio>
                                                </div>

                                                <div class="col-sm-4">
                                                    <radio name="pickups" :value="true" v-model="pickups" @input="pickupsOptionChanged">
                                                        Pickup Lists
                                                    </radio>
                                                </div>
                                            </div>

                                        </div>

                                        <div v-if="pickups">

                                            <div v-if="routes.length > 0">
                                                <div class="row border-bottom-light pb-2">
                                                    <div class="col-sm-10">
                                                    </div>
                                                    <div class="col-sm-2 text-center fs-smaller dark font-weight-600">
                                                        Locations
                                                    </div>
                                                </div>

                                                <div class="row align-items-center border-bottom-light py-2 darker" v-for="route in routes">
                                                    <div class="col-sm-1">
                                                        <checkbox v-model="route.checked" @input="routeCheckChanged"></checkbox>
                                                    </div>
                                                    <div class="col-sm-9">
                                                        <div class="font-weight-600">
                                                            <span class="lightest fs-small bg-dark radius-normal mr-1 px-2">{{(route.type == 1)? 'Pickup' : 'Dropoff'}}</span>
                                                            <span>{{route.name}}</span>
                                                        </div>
                                                        <div>
                                                            <span v-for="(itenerary, index) in route.iteneraries" class="fs-small dark">
                                                                <span>{{itenerary.stop.name}}</span><span v-if="index+1 < route.iteneraries.length">, </span>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-2 text-center font-weight-600 fs-small">
                                                        {{route.iteneraries.length}}
                                                    </div>
                                                </div>

                                                <!-- <div class="add d-flex align-items-center pointer fs-small bold mt-5" @click="createPickupList">
                                                    <i class="ico-add fs-smallest add-circle color-1"></i> Create new pickup list
                                                </div> -->

                                            </div>

                                            <div v-else class="text-center dark pb-4 pt-4">
                                                <span>🚌 Looks like you have no pickup or dropoff lists created, you can create them on your inventory.</span>
                                            </div>

                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="d-flex justify-content-end align-items-center border-bottom-light my-4 p-4">
                            <button type="button" class="btn blue wider mr-3" @click="prevStep"><i class="ico-arrow-left fs-normal ml-2"></i> Back</button>
                            <button type="button" class="btn cancel wider mr-3" @click="cancel">Cancel</button>
                            <button type="button" class="btn green wider mr-3" @click="readyToSave">Save</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import Steps from './ProductSteps'
    import extendedVSelect from '@/extends/vue-select'
    import { requiredIf, withParams, numeric } from 'vuelidate/lib/validators'

    export default {
        props: {
            currentStep: Number,
        },
        data: function() {
            return {
                step: 5,
                form: {},
                pickups: false,
            }
        },
        created: function() {
            this.routes = this.getAllRoutes
            this.form = JSON.parse(JSON.stringify(this.getClonedItem))

            //if editing a product
            if(this.form.routes.length > 0){
                this.pickups = true;

                //mark product routes marked
                this.markProductRoutes();
            }

        },
        computed: {
            ...mapGetters([
                'account',
                'getSelectedItem',
                'getClonedItem',
                'getPickupRoutes',
                'getAllRoutes'
            ]),
            symbol: function() {
                return this.selectedDeposit.symbol;
            }
        },
        methods: {
            ...mapActions([
                'openModal'
            ]),
            cancel: function() {
                this.$emit('cancelling');
            },
            switchStep: function(step) {
                this.$emit('goToStep', { invalid: false, form: this.form, step: (step !== undefined && !isNaN(step)) ? step : (this.currentStep + 1) });
            },
            prevStep: function(step) {
                this.$emit('goToStep', { invalid: false, form: this.form, step: (step !== undefined && !isNaN(step) ) ? step : (this.currentStep - 1) });
            },
            nextStep: function(step) {
                this.$emit('goToStep', { invalid: false, form: this.form, step: (step !== undefined && !isNaN(step)) ? step : (this.currentStep + 1) });
            },
            readyToSave: function() {
                this.$emit('readyToSave', { invalid: false, form: this.form });
            },
            createPickupList: function() {
                this.openModal('CreatePickupList');
            },
            routeCheckChanged: function(e) {
                this.form.routes = this.routes.filter(route => {
                    return route.checked
                })
            },
            markProductRoutes: function() {
                this.routes.map(availableRoute => {
                    this.form.routes.map(productRoute => {
                        if(productRoute.id == availableRoute.id){
                            this.$set(availableRoute, 'checked', true)
                        }
                    })
                })
            },
            pickupsOptionChanged:function (e) {
                // if(e == false){
                    this.form.routes = []
                    this.routes.map(availableRoute => {
                        this.$set(availableRoute, 'checked', false)
                    })
                    this.markProductRoutes()
                // }
            }
        },
        components: {
            Steps,
            vSelect: extendedVSelect
        }
    }
</script>



// WEBPACK FOOTER //
// ProductPickups.vue?0c7d2db8